import Const from 'constants';

const defaultState = {
    data: {
        uniquePlayersQuantity: Const.DEFAULT_UNIQUE_PLAYERS_QUANTITY,
    },
    getUniquePlayersQuantity() {
        return this.data.uniquePlayersQuantity;
    },
};

export default function (state = defaultState, action) {
    if (action.type === Const.SET_UNIQUE_PLAYERS_QUANTITY) {
        state = {...state, data: {uniquePlayersQuantity: action.value}};
    } else if (inArray(action.type, [Const.RESET_ALL_SETTINGS, Const.FILTER_BY_SLATE])) {
        state = {...defaultState, data: {uniquePlayersQuantity: 1}};
    }

    return state;
}
